/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  Router,
  Route,
  IndexRoute,
  Link,
  hashHistory,
  browserHistory,
} from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import configureStore from "./redux/configureStore";
import Main from "./components/main/Main";
import MainLog from "./components/main/MainLog";
import MainPortfolio from "./components/main/MainPortfolio";
// Logs
import Log from "./components/logs/Log";
// Gardens
import Garden from "./components/gardens/Garden";
// Client work
import Project from "./components/projects/Project";
import "typeface-roboto";
import registerServiceWorker from "./registerServiceWorker";
import "./index.scss";

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={Main}>
        <Route path="/logs" component={Log} project="logs" title="Logs">
          <Route path="/2016" component={Log} project="logs" title="Logs">
            <Route
              path="spirit-of-github"
              component={Log}
              project="logs"
              title="Logs"
            />
          </Route>
        </Route>
        <Route
          path="/gardens"
          component={Garden}
          project="garden"
          title="Garden"
        >
          <Route
            path="/gardens/2020"
            component={Garden}
            project="Garden"
            title="Garden"
          >
            <Route
              path="/gardens/2020/cross-country-grid"
              component={Garden}
              project="cross-country-grid"
              title="Cross Country Grid"
            />
          </Route>
        </Route>
        <Route path="/portfolio" component={MainPortfolio}>
          <Route
            path="/bio"
            component={Project}
            project="bio"
            title="Brandon Flowers"
          />
          <Route
            path="/mitsubishi"
            component={Project}
            project="mitsubishi"
            title="Mitsubishi Lancer Earth"
          />
          <Route
            path="/bmw"
            component={Project}
            project="bmw"
            title="BMW Car Calculator"
          />
          <Route
            path="/totaldrama"
            component={Project}
            project="totaldrama"
            title="Total Drama Avatar Builder"
          />
          <Route
            path="/nintendo"
            component={Project}
            project="nintendo"
            title="Nintendo Wii Fit"
          />
          <Route
            path="/labatt"
            component={Project}
            project="labatt"
            title="Labatt Wolf Pack"
          />
          <Route
            path="/bacardi"
            component={Project}
            project="bacardi"
            title="Bacardi 360 Video"
          />
          <Route
            path="/microsoft"
            component={Project}
            project="microsoft"
            title="Microsoft World Tour"
          />
          <Route
            path="/toda"
            component={Project}
            project="toda"
            title="Toda Blockchan Service"
          />
          <Route
            path="/camh"
            component={Project}
            project="camh"
            title="CAMH: Thoughtspot"
          />
          <Route
            path="/trioova"
            component={Project}
            project="trioova"
            title="Trioova Marketplace"
          />
          <Route path="/247" component={Project} project="247" title="247 AI" />
          <Route
            path="/ada"
            component={Project}
            project="ada"
            title="Ada Support"
          />
          <Route
            path="/budding-data-scientist"
            component={Project}
            project="wind"
            title="US Wind Energy"
          />
        </Route>
      </Route>
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js